<template>
  <div>
    <div class="d-flex align-content-between align-items-start">
      <v-select 
        class="flex-grow-1"
        :value="value" 
        :loading="loading"
        :options="dieticians" 
        :close-on-select="true"
        :reduce="val => val.id" 
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
        label="name" 
        clearable 
        @search="fetchDieticians"
        @input="onOptionSelected"
      >
        <template #list-header>
          <li class="d-flex align-content-between align-items-center" style="opacity: 0.8; text-align: center; padding: 5px;">
            <div class="flex-grow-1">Start typing to fetch dieticians</div>
          </li>
        </template>

        <template #no-options>
          No options available
        </template>
      </v-select>
    </div>
  </div>
</template>
  
<script>
import { get } from 'lodash';
import { BButton } from 'bootstrap-vue'

import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
  
export default {
  components: {
    vSelect,
    BButton,

  },
  props: {
    value: {
      default: "",
      type: String,
      required: false,
    }
  },
  data() {
    return {
      loading: false,
      toggleModal: false,

      dieticians: [],
      storeName: "dieticianFrequencyStore",
    }
  },
  created() {
    if (this.value){
      this.fetchDieticians(this.value, () => {});
    } else {
      this.dieticians = this.getFrequencyStore(this.storeName)
    }
  },
  methods: {
    async fetchDieticians(text, loadingMutator) {
      try {
        this.loading = true; 
        loadingMutator(true);

        const query = {
          page: 1,
          limit: 50,
          search: text || this.value,
          status: 'active',
          profession: 'dietician'
        }
        
        const request = await this.useJwt().mainService.users.list(query);
        const { data } = request.data;
        this.dieticians = data.map(opt => ({ id: opt._id, name: `${opt.full_name} | ${opt.email}` }))
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
        loadingMutator(false);
      }
    },
    onOptionSelected(dietician_id){
      this.$emit('change', dietician_id)

      const selectedOption = this.dieticians.find(record => record.id === dietician_id);
      if (selectedOption) {
        this.updateFrequencyStore(this.storeName, selectedOption);
      }
    },
  }
}
</script>
